import * as React from 'react';
import { Capacitor } from '@capacitor/core';
import { useWindowWidth } from '../../hooks/useWindowSize';

import {
  InputWrapper,
  InputLabelWrapper,
  InputLabel,
  ErrorMessage,
  ITextInput,
  InputDecoratorLeft,
  InputDecoratorRight,
} from './inputs';

export const RHFTextInput = ({
  id,
  ariaLabel,
  ref,
  autoComplete,
  autoFocus,
  testid,
  name,
  label,
  register,
  options,
  error,
  value,
  decoratorLeft,
  decoratorRight,
  placeholder,
  type = 'text',
  inputMode,
  pattern,
  onFocus,
  enterKeyHint,
  tabIndex,
}: ITextInput) => {
  const { isTablet } = useWindowWidth();
  return (
    <InputWrapper
      error={!!error}
      filled={typeof value === 'string' ? !!value.length : !!value}
      decoratorLeft={!!decoratorLeft}
      decoratorRight={!!decoratorRight}
    >
      <input
        data-sentry-mask
        id={id}
        aria-label={ariaLabel}
        ref={ref}
        type={type}
        inputMode={inputMode}
        pattern={pattern}
        autoFocus={Capacitor.isNativePlatform() || isTablet ? false : autoFocus}
        {...register(name, options)}
        data-testid={testid}
        autoComplete={autoComplete}
        placeholder={placeholder}
        onFocus={onFocus}
        enterKeyHint={enterKeyHint}
        tabIndex={tabIndex}
      />
      {label && (
        <InputLabelWrapper>
          <InputLabel htmlFor={id} decoratorLeft={!!decoratorLeft}>
            {label}
          </InputLabel>
        </InputLabelWrapper>
      )}
      {decoratorLeft && <InputDecoratorLeft>{decoratorLeft}</InputDecoratorLeft>}
      {decoratorRight && <InputDecoratorRight>{decoratorRight}</InputDecoratorRight>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};
